<template>
  <div>
    <!-- sfsfs -->
    <div class="page-wrapper" style="font-size: 12px">
      <div class="page-content-wrapper ml-0 px-3 pt-3">
        <h5 class="font-18 title-bld">
          <a v-on:click="redirectTo()" class="mr-3"
            ><i class="bx bx-arrow-back cursor-pointer"></i
          ></a>
          {{ uuid ? "Edit" : "Add" }} User
        </h5>
        <div>
          <ul
            class="nav nav-pills col-12 row p-0 m-0"
            id="myTab"
            role="tablist"
            v-if="uuid">
            <li class="nav-item cursor-pointer mb-3 col-6 p-0 m-0">
              <a
                class="nav-link active"
                data-toggle="tab"
                style="
                  cursor: pointer;
                  font-size: 14px;
                  text-align: center;
                  align-content: end;
                  background-color: white;
                "
                :class="{ active: currentTab == 'BASIC_INFO' }"
                v-on:click="changeTab('BASIC_INFO')">
                <span> Basic Information</span></a
              >
            </li>
            <li class="nav-item cursor-pointer col-6 p-0 m-0">
              <a
                class="nav-link"
                data-toggle="tab"
                style="
                  cursor: pointer;
                  font-size: 14px;
                  text-align: center;
                  align-content: end;
                  background-color: white;
                "
                v-on:click="
                  $router.push('/subscription-plan-history/' + this.uuid)
                ">
                <span>Subscription History</span></a
              >
            </li>
          </ul>
          <div class="tab-content mt-2 form-style" id="memberInfo-tabContent">
            <div
              class="tab-pane fade show active"
              id="BasicInfo"
              role="tabpanel"
              aria-labelledby="BasicInfo-tab">
              <div
                class="row"
                v-if="
                  detail.deleted_reason_other &&
                  detail.status == 'DELETED' &&
                  uuid
                ">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header py-2" style="background: #feccc9">
                      <p
                        class="h6 mb-0"
                        style="font-size: 13px; font-weight: bold"
                        v-if="detail.deleted_reason_other">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        Delete Reason:&nbsp;
                        {{ detail.deleted_reason_other }} ({{
                          detail.delete_reason
                            ? detail.delete_reason.type.replaceAll("_", " ")
                            : ""
                        }})
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <Form ref="saved" @submit="save()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header py-2">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Personal Details
                        </p>
                      </div>
                      <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-md-4">
                            <label for="">Reg. No.</label>
                            <div class="mb-0">
                              <!-- {{ detail.registration_no }} -->

                              <Field
                                type="text"
                                name="registration_no"
                                placeholder="Registration Number"
                                v-model="detail.registration_no"
                                class="form-control"></Field>
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Gender</label>
                            <span class="text-danger">*</span>
                            <div class="d-flex">
                              <div class="form-check p-0">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="genderType"
                                  id="male1"
                                  value="M"
                                  v-model="detail.gender" />
                                <label class="" for="male1">Male</label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="genderType"
                                  id="female1"
                                  value="F"
                                  v-model="detail.gender" />
                                <label class="" for="female1"> Female </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Marital Status</label>
                            <span class="text-danger">*</span>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="marrital_status"
                              v-model="detail.marital_status_id"
                              rules="required: marital status, true">
                              <option value="">Select Status</option>
                              <option
                                v-for="(data, index) in marriedStatusListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="marrital_status"
                              class="text-danger" />
                          </div>
                          <div class="col-6" style="display: none">
                            <label for="">Mobile Number</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="phone"
                              placeholder="Phone Number"
                              v-slot="{ field }"
                              v-model="detail.mobile"
                              class="form-control mobile_no"
                              rules="required:Mobile Number"
                              :validateOnInput="true">
                              <PhoneCode
                                id="mobile"
                                placeholder="Mobile Number"
                                v-model:countryCode="detail.country_code"
                                v-model="detail.mobile"
                                v-model:dialCode="detail.mobile_country_code"
                                v-bind="field" />
                            </Field>
                            <ErrorMessage name="phone" class="text-danger" />
                          </div>
                          <div class="col-md-6 mb-2" style="display: none">
                            <div class="form-group">
                              <label>Email</label>
                              <span class="text-danger">*</span>
                              <Field
                                type="text"
                                name="personal_email"
                                class="form-control"
                                placeholder="Email"
                                v-model="detail.email"
                                rules="required: Email|email"
                                :validateOnInput="true" />
                              <ErrorMessage
                                name="personal_email"
                                class="text-danger" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <label for=""
                              >Name<span class="text-danger">*</span></label
                            >
                          </div>

                          <!-- <div class="col-md-12 mb-2"> -->
                          <div class="col-md-4 form-group">
                            <Field
                              type="text"
                              name="first_name"
                              class="form-control gery-light"
                              placeholder="First Name"
                              v-model="detail.first_name"
                              @keypress="$helperService.maxInput($event, 15)"
                              rules="required:first name|maxLength:15"
                              :validateOnInput="true" />
                            <ErrorMessage
                              name="first_name"
                              class="text-danger" />
                          </div>
                          <div class="col-md-4 form-group">
                            <Field
                              type="text"
                              name="middle_name"
                              class="form-control gery-light"
                              placeholder="Middle Name"
                              @keypress="$helperService.maxInput($event, 15)"
                              rules="maxLength:15"
                              v-model="detail.middle_name" />
                            <ErrorMessage
                              name="middle_name"
                              class="text-danger" />
                          </div>
                          <div class="col-md-4 form-group">
                            <Field
                              type="text"
                              name="last_name"
                              class="form-control"
                              placeholder="Last Name"
                              v-model="detail.last_name"
                              @keypress="$helperService.maxInput($event, 25)"
                              rules="required:last name"
                              :validateOnInput="true" />
                            <ErrorMessage
                              name="last_name"
                              class="text-danger" />
                          </div>
                          <!-- </div> -->
                          <!-- <div class="col-md-4 mb-2">
                           
                          </div>
                          <div class="col-md-4 mb-2">
                         
                          </div> -->
                        </div>
                        <div class="row">
                          <div class="col-md-4 mb-2">
                            <div class="form-group">
                              <label>Native Gaon</label>
                              <!-- <span class="text-danger">*</span> -->
                              <Field
                                type="text"
                                name="native_place"
                                class="form-control gery-dark"
                                placeholder="Native Gaon"
                                @keypress="$helperService.maxInput($event, 12)"
                                v-model="detail.native_place_goan" />
                              <!-- <ErrorMessage
                                name="native_place"
                                class="text-danger"
                              /> -->
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Native Taluka</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control gery-dark"
                              id="inputRole"
                              name="native_place_taluka"
                              v-model="detail.native_place_taluka_id">
                              <option value="">Select Taluka</option>
                              <option
                                v-for="(data, index) in nativeTalukaList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage
                              name="native_place_taluka"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Native District</label>
                            <span class="text-danger">*</span>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="native_place_district"
                              v-model="detail.native_place_district_id"
                              rules="required: district, true">
                              <option value="">Select District</option>
                              <option
                                v-for="(data, index) in districtList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="native_place_district"
                              class="text-danger" />
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Date Of Birth</label>
                            <span class="text-danger">*</span>
                            <CustomDatepicker
                              @update="changeBOD($event)"
                              :modelValue="detail.dob"
                              ref="dobDatePicker" />
                          </div>
                          <!-- <div class="col-md-4 mb-2">
                            <label for="">Date of Birth</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="dob"
                              placeholder="Select date of birth"
                              rules="required:date of birth"
                              v-model="detail.dob"
                              :validateOnInput="true"
                              v-slot="{ field }"
                            >
                              <Datepicker
                                autoApply
                                v-model="detail.dob"
                                inputFormat="dd-MM-yyyy"
                                format="dd-MM-yyyy"
                                placeholder="Select date of birth"
                                :maxDate="new Date()"
                                v-bind="field"
                              />
                              <ErrorMessage name="dob" class="text-danger" />
                            </Field>
                          </div> -->
                          <div class="col-md-4 mb-2">
                            <label for="">Height</label>
                            <span class="text-danger">*</span>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="new_height"
                              rules="required:Height"
                              :validateOnInput="true"
                              v-model="detail.height">
                              <option value="">Select Height</option>
                              <option
                                :value="detail.height"
                                v-if="detail.height">
                                {{ $helperService.getHeight(detail.height) }}
                              </option>
                              <option value="139">
                                {{ $helperService.getHeight(139) }}
                              </option>
                              <option value="142">
                                {{ $helperService.getHeight(142) }}
                              </option>
                              <option value="144">
                                {{ $helperService.getHeight(144) }}
                              </option>
                              <option value="147">
                                {{ $helperService.getHeight(147) }}
                              </option>
                              <option value="149">
                                {{ $helperService.getHeight(149) }}
                              </option>
                              <option value="152">
                                {{ $helperService.getHeight(152) }}
                              </option>
                              <option value="154">
                                {{ $helperService.getHeight(154) }}
                              </option>
                              <option value="157">
                                {{ $helperService.getHeight(157) }}
                              </option>
                              <option value="160">
                                {{ $helperService.getHeight(160) }}
                              </option>
                              <option value="162">
                                {{ $helperService.getHeight(162) }}
                              </option>
                              <option value="165">
                                {{ $helperService.getHeight(165) }}
                              </option>
                              <option value="167">
                                {{ $helperService.getHeight(167) }}
                              </option>
                              <option value="170">
                                {{ $helperService.getHeight(170) }}
                              </option>
                              <option value="172">
                                {{ $helperService.getHeight(172) }}
                              </option>
                              <option value="175">
                                {{ $helperService.getHeight(175) }}
                              </option>
                              <option value="177">
                                {{ $helperService.getHeight(177) }}
                              </option>
                              <option value="180">
                                {{ $helperService.getHeight(180) }}
                              </option>
                              <option value="182">
                                {{ $helperService.getHeight(182) }}
                              </option>
                              <option value="185">
                                {{ $helperService.getHeight(185) }}
                              </option>
                              <option value="187">
                                {{ $helperService.getHeight(187) }}
                              </option>
                              <option value="190">
                                {{ $helperService.getHeight(190) }}
                              </option>
                              <option value="192">
                                {{ $helperService.getHeight(192) }}
                              </option>
                              <option value="195">
                                {{ $helperService.getHeight(195) }}
                              </option>
                              <option value="198">
                                {{ $helperService.getHeight(198) }}
                              </option>
                              <option value="200">
                                {{ $helperService.getHeight(200) }}
                              </option>
                              <option value="203">
                                {{ $helperService.getHeight(203) }}
                              </option>
                              <option value="205">
                                {{ $helperService.getHeight(205) }}
                              </option>
                              <option value="208">
                                {{ $helperService.getHeight(208) }}
                              </option>
                              <option value="210">
                                {{ $helperService.getHeight(210) }}
                              </option>
                              <option value="213">
                                {{ $helperService.getHeight(213) }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="new_height"
                              class="text-danger" />
                            <!-- <ErrorMessage name="height" class="text-danger" /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Body Structure</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="body_structure"
                              v-model="detail.body_structure_id">
                              <option value="">Select Body structure</option>
                              <option
                                v-for="(data, index) in bodyStructureListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage
                              name="body_structure"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Blood Group</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="blood_group"
                              v-model="detail.blood_group">
                              <option value="">Select</option>
                              <option value="A +ve">A +ve</option>
                              <option value="A -ve">A -ve</option>
                              <option value="B +ve">B +ve</option>
                              <option value="B -ve">B -ve</option>
                              <option value="O +ve">O +ve</option>
                              <option value="O -ve">O -ve</option>
                              <option value="AB +ve">AB +ve</option>
                              <option value="AB -ve">AB -ve</option>
                            </Field>
                            <!-- <ErrorMessage
                              name="blood_group"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Skin Tone</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="skin_tone"
                              v-model="detail.scan_tone_id">
                              <option value="">Select Skintone</option>
                              <option
                                v-for="(data, index) in skintoneList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage
                              name="skin_tone"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Diet</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="diet"
                              v-model="detail.diet_id">
                              <option value="">Select Diet</option>
                              <option
                                v-for="(data, index) in dietListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="diet" class="text-danger" /> -->
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Education/Courses</label>
                            <span class="text-danger">*</span>
                            <Field
                              as="textarea"
                              name="education_courses"
                              placeholder="Education/Courses"
                              v-model="detail.education_courses"
                              @keypress="$helperService.maxInput($event, 135)"
                              rules="required:education courses"
                              :validateOnInput="true"
                              id=""
                              rows="4"
                              class="form-control h-auto"
                              style="height: 110px !important"></Field>
                            <ErrorMessage
                              name="education_courses"
                              class="text-danger" />
                          </div>
                          <div class="col-md-6 mb-2">
                            <div class="col-md-12 mb-2">
                              <label for="">Per.</label>
                              <!-- <span class="text-danger">*</span> -->
                              <Field
                                as="select"
                                class="form-control"
                                id="personality_id"
                                name="personality_id"
                                v-model="detail.personality_id">
                                <option value="">Select Per.</option>
                                <option
                                  v-for="(data, index) in personalityListNew"
                                  :key="index"
                                  :value="data.uuid">
                                  {{ data.name }}
                                </option>
                              </Field>
                              <!-- <ErrorMessage
                                name="personality_id"
                                class="text-danger"
                              /> -->
                            </div>
                            <div class="col-md-12 mb-2">
                              <label for="">Education Group</label>
                              <span class="text-danger">*</span>
                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="education_group"
                                v-model="detail.education_group_id"
                                rules="required: eductaion group, true">
                                <option value="">Select Education Group</option>
                                <option
                                  v-for="(data, index) in educationGroupListNew"
                                  :key="index"
                                  :value="data.uuid">
                                  {{ data.name }}
                                </option>
                              </Field>
                              <ErrorMessage
                                name="education_group"
                                class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Occupation Type</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="occupation_type_id"
                              name="occupation_type_id"
                              v-model="detail.occupation_type_id">
                              <option value="">Select Occupation Type</option>
                              <option
                                v-for="(data, index) in occupationTypeListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage
                              name="occupation_type_id"
                              class="text-danger"
                            /> -->
                            <!-- <ErrorMessage
                              name="occupation_type"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Occupation Detail</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              type="text"
                              name="occupation_details"
                              placeholder="Occupation Detail"
                              @keypress="$helperService.maxInput($event, 48)"
                              v-model="detail.occupation_details"
                              class="form-control"></Field>
                            <!-- <ErrorMessage
                              name="occupation_details"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Ann. Income</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="annual_income"
                              placeholder="In Lakh"
                              v-model="detail.annual_income"
                              rules="required:annual income"
                              :validateOnInput="true"
                              class="form-control"
                              @keypress="
                                $helperService.allowOnlyNumericValue($event)
                              "></Field>
                            <ErrorMessage
                              name="annual_income"
                              class="text-danger" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Work Location</label>
                            <span class="text-danger">*</span>
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="working_place_taluka"
                              v-model="detail.working_place_taluka_id"
                              rules="required: work location,true">
                              <option value="">Select Work Location</option>
                              <option
                                v-for="(data, index) in worklocationList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <ErrorMessage
                              name="working_place_taluka"
                              class="text-danger" />
                          </div>
                          <div class="col mb-2 ps-2">
                            <Field
                              type="text"
                              name="working_place_goan"
                              @keypress="$helperService.maxInput($event, 20)"
                              class="form-control gery-dark"
                              placeholder="Gaon/Area"
                              v-model="detail.working_place_goan" />
                            <!-- <ErrorMessage
                              name="working_place_goan"
                              class="text-danger"
                            /> -->
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12 mb-2">
                            <label for="">Other Information</label>
                            <Field
                              type="text"
                              name="other_info"
                              class="form-control"
                              @keypress="$helperService.maxInput($event, 45)"
                              placeholder="Other Info"
                              v-model="detail.other_info" />
                            <!-- <ErrorMessage
                              name="other_info"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">Birth Time</label>
                            <Datepicker
                              autoApply
                              placeholder="Select Time"
                              :is-24="false"
                              v-model="detail.birth_time"
                              timePicker />
                            <!-- <ErrorMessage
                              name="birth_time"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">District</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="birth_district"
                              v-model="detail.birth_district_id">
                              <option value="">Select District</option>
                              <option
                                v-for="(data, index) in districtList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage
                              name="birth_district"
                              class="text-danger"
                            /> -->
                          </div>
                          <!-- <div class="col-md-3 mb-2 ps-2">
                            <label for="">Gun</label>
                            <Field
                              type="text"
                              name="gun"
                              placeholder="Gun"
                              v-model="detail.gun"
                              class="form-control"
                              @keypress="
                                $helperService.allowOnlyNumericValue($event)
                              "
                            ></Field>
                            <ErrorMessage name="gun" class="text-danger" />
                          </div> -->
                          <div class="col-md-4 mb-2 ps-2">
                            <label for="">Mangal</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="mangal"
                              v-model="detail.is_mangal">
                              <option value="">Select Mangal</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                              <option value="SOUMYA">Soumya</option>
                              <option value="NIRDOSH">Nirdosh</option>
                              <option value="NOT_KNOWN">Not Known</option>
                              <option value="NO,">No,</option>
                            </Field>
                            <!-- <ErrorMessage name="mangal" class="text-danger" /> -->
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Horoscope Details</label>
                            <!-- <span class="text-danger">*</span> -->
                          </div>
                          <div class="col mb-2 pe-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="rashi"
                              v-model="detail.raas_id">
                              <option value="">Select Rashi</option>
                              <option
                                v-for="(data, index) in rashiList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="rashi" class="text-danger" /> -->
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="nakshtra"
                              v-on:change="getCharan(detail.nakshatra_id)"
                              v-model="detail.nakshatra_id">
                              <option value="">Select Nakshtra</option>
                              <option
                                v-for="(data, index) in nakshtraList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="nakshtra" class="text-danger" /> -->
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="charan"
                              v-model="detail.charan_id">
                              <option value="">Select Charan</option>
                              <option
                                v-for="(data, index) in charanList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="charan" class="text-danger" /> -->
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="nadi"
                              v-model="detail.nadi_id">
                              <option value="">Select Nadi</option>
                              <option
                                v-for="(data, index) in nadiList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="nadi" class="text-danger" /> -->
                          </div>
                          <div class="col mb-2 px-2">
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="gan"
                              v-model="detail.gan_id">
                              <option value="">Select Gan</option>
                              <option
                                v-for="(data, index) in ganList"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                            <!-- <ErrorMessage name="gan" class="text-danger" /> -->
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label for="">Devak</label>
                            <div class="com-md-6">
                              <!-- <Field
                                type="text"
                                name="devak"
                                placeholder="Devak"
                                @keypress="$helperService.maxInput($event, 24)"
                                v-model="detail.devak"
                                class="form-control"></Field> -->
                              <!-- <label for="">Devak</label> -->
                              <Field
                                as="select"
                                class="form-control"
                                id="devak"
                                name="devak"
                                v-model="detail.devak">
                                <option value="">Select Devak</option>
                                <option
                                  v-for="(data, index) in devakList"
                                  :key="index"
                                  :value="data.id">
                                  {{ data.name }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Ready to move Abroad?</label>
                            <!-- <span class="text-danger">*</span> -->
                            <div class="">
                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="ready_to_move_abrod"
                                v-model="detail.ready_to_move_abrod">
                                <option value="">Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                                <option value="UNDECIDED">Undecided</option>
                                <option value="ALREADY_IN">Already in</option>
                              </Field>
                              <!-- <ErrorMessage
                                name="ready_to_move_abrod"
                                class="text-danger"
                              /> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2 bg-light border-top">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Expectations
                        </p>
                      </div>
                      <div class="card-body pt-2">
                        <div class="row form-group">
                          <div class="col-md-6 form-group">
                            <label for="">Marital Status</label>
                            <!-- <span class="text-danger">*</span> -->
                            <div>
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="marrital_status"
                                v-model="detail.expectation.marital_status"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="marriedStatusList"
                                placeholder="Marital Status"
                                object="true"
                                @select="SelectAllMarriedList($event)" />
                            </div>
                            <!-- <ErrorMessage
                              name="marrital_status"
                              class="text-danger"
                            /> -->
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Same Devak</label>
                            <div class="">
                              <Field
                                as="select"
                                class="form-control"
                                id="same_devak"
                                name="same_devak"
                                v-model="detail.expectation.same_devak">
                                <option value="">Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                              </Field>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <label for="">Occupation</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="occupation_type"
                                v-model="detail.expectation.occupation_type"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="occupationTypeList"
                                placeholder="Occupation"
                                object="true"
                                @select="SelectAllOcupationList($event)" />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <label for="">Body Structure</label>
                            <Multiselect
                              style="
                                font-size: 14px;
                                color: #000;
                                font-weight: 500;
                              "
                              mode="tags"
                              :searchable="true"
                              name="body_structure"
                              v-model="detail.expectation.body_structure"
                              trackBy="name"
                              label="name"
                              valueProp="uuid"
                              :options="bodyStructureList"
                              placeholder="Body Structure"
                              object="true"
                              @select="SelectAllBoadyStructureList($event)" />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label for="">Birth Year</label>
                            <div class="d-flex align-items-center">
                              <Datepicker
                                autoApply
                                placeholder="Select Year"
                                v-model="detail.expectation.birth_year_from"
                                :minDate="detail.expectation.birth_year_from"
                                yearPicker />
                              <label class="mb-0 mx-1">To</label>
                              <Datepicker
                                autoApply
                                placeholder="Select Year"
                                v-model="detail.expectation.birth_year_to"
                                :maxDate="new Date()"
                                yearPicker />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Height</label>
                            <div class="d-flex align-items-center">
                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="height_from"
                                v-model="detail.expectation.height_from">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                              <label class="mb-0 mx-1">To</label>
                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="height_to"
                                v-model="detail.expectation.height_to">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 mb-2">
                            <label for="">Diet</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="diet"
                                v-model="detail.expectation.diet"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="dietList"
                                placeholder="Diet"
                                object="true"
                                @select="SelectAllDietList($event)" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Patrika Match</label>
                            <div class="">
                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="patrika_match"
                                v-model="detail.expectation.patrika_match">
                                <option value="">Select Patrika Match</option>
                                <option value="ALL">Flexible</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-12 mb-2">
                            <label for="">Education Group</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="expectation_education_group"
                                v-model="detail.expectation.education_group"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="educationGroupList"
                                placeholder="Education Group"
                                object="true"
                                @select="SelectAllEducationList($event)" />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <label for="">Ready Move to Abroad</label>
                            <!-- <span class="text-danger">*</span> -->
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="move_to_abroad"
                                v-model="detail.expectation.move_to_abroad"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="moveToAbroadList"
                                placeholder="Move to Abroad"
                                object="true"
                                @select="SelectAllMoveToAbroadList($event)" />
                              <!-- <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="move_to_abroad"
                                v-model="detail.expectation.move_to_abroad"
                              >
                                <option value="" >Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                                <option value="UNDECIDED">Undecided</option>
                                <option value="ALREADY_IN">Already in</option>
                              </Field> -->
                              <!-- <ErrorMessage
                                name="move_to_abroad"
                                class="text-danger"
                              /> -->
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="">Mangal</label>
                            <!-- <span class="text-danger">*</span> -->
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="mangal"
                                v-model="detail.expectation.mangal"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="mangalList"
                                placeholder="Mangal"
                                @select="SelectAllMangal($event)" />
                              <!-- <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="move_to_abroad"
                                v-model="detail.expectation.move_to_abroad"
                              >
                                <option value="" >Select</option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                                <option value="UNDECIDED">Undecided</option>
                                <option value="ALREADY_IN">Already in</option>
                              </Field> -->
                              <!-- <ErrorMessage
                                name="move_to_abroad"
                                class="text-danger"
                              /> -->
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Work Location</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="working_city"
                                v-model="detail.expectation.working_city"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="worklocationList"
                                placeholder="Select Work Location"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Native District</label>
                            <div class="">
                              <Multiselect
                                :disabled="
                                  detail?.expectation?.native_taluka?.length > 0
                                "
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="native_district"
                                v-model="detail.expectation.native_district"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="districtList"
                                placeholder="Select Native District"
                                object="true" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Native Taluka</label>
                            <Multiselect
                              :disabled="
                                detail?.expectation?.native_district?.length > 0
                              "
                              style="
                                font-size: 14px;
                                color: #000;
                                font-weight: 500;
                              "
                              mode="tags"
                              :searchable="true"
                              name="native_taluka"
                              v-model="detail.expectation.native_taluka"
                              trackBy="name"
                              label="name"
                              valueProp="uuid"
                              :options="nativeTalukaList"
                              placeholder="Select Native Taluka"
                              object="true" />
                          </div>
                          <!-- <div class="col-md-6 mb-2">
                            <label for="">Family Residence</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="nativeTalukaList"
                                v-model="detail.expectation.family_residence"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="nativeTalukaList"
                                placeholder="Select Taluka"
                                object="true" />
                            </div>
                          </div> -->

                          <div class="col-md-6 mb-2">
                            <label for="">Per.</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="personality"
                                v-model="detail.expectation.personality"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="personalityList"
                                placeholder="Per."
                                object="true"
                                @select="SelectAllpersonalityList($event)" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Relations</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="relation"
                                :groupSelect="true"
                                v-model="detail.expectation.relation"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="relationList"
                                placeholder="Relations"
                                object="true"
                                @select="SelectAllrelationList($event)" />
                            </div>
                          </div>
                          <div class="col-md-6 mb-2">
                            <label for="">Eco. Status</label>
                            <div class="">
                              <Multiselect
                                style="
                                  font-size: 14px;
                                  color: #000;
                                  font-weight: 500;
                                "
                                mode="tags"
                                :searchable="true"
                                name="echo_status"
                                v-model="detail.expectation.echo_status"
                                trackBy="name"
                                label="name"
                                valueProp="uuid"
                                :options="echoStatusList"
                                placeholder="Eco. Status"
                                object="true"
                                @select="SelectAllEcho" />
                            </div>
                          </div>
                          <!-- <div class="col-md-6 mb-2">
                            <label for="">Expected Education</label>
                            <Field
                              as="textarea"
                              name="expected_educations"
                              placeholder="Expected Educations"
                              v-model="detail.expectation.expected_educations"
                              id=""
                              rows="2"
                              class="form-control h-auto"
                            ></Field>
                          </div> -->
                          <div class="col-md-12 mb-2">
                            <label for=""> Expectations</label>
                            <Field
                              as="textarea"
                              name="occupation_other_expectations"
                              @keypress="$helperService.maxInput($event, 80)"
                              placeholder="Expectations"
                              v-model="
                                detail.expectation.occupation_other_expectations
                              "
                              id=""
                              rows="2"
                              class="form-control h-auto"
                              style="height: 50px !important"></Field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header py-2">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Profile Images
                        </p>
                      </div>

                      <div class="row px-4">
                        <div
                          class="col-lg-4"
                          v-for="(data, index) in detail.user_images"
                          :key="index">
                          <div class="mt-4" v-if="index < 2">
                            <ProductImagePicker
                              @add-image="addImage($event, index)"
                              @update-image="updateImage($event, index)"
                              :src="data.image"
                              :modelValue="data.image"
                              :index="index"
                              :ref="'productImagePicker_' + index"
                              @removeImage="
                                showremoveImagePopup(data, index)
                              " />
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Family Details
                        </p>
                      </div>

                      <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-4">
                                <label for="">Contact Full Name</label>
                                <!-- <span class="text-danger">*</span> -->

                                <Field
                                  type="text"
                                  name="contact_full_name"
                                  placeholder="Contact Full Name"
                                  @keypress="
                                    $helperService.maxInput($event, 55)
                                  "
                                  v-model="
                                    detail.family_details.contact_full_name
                                  "
                                  id=""
                                  rows="4"
                                  class="form-control h-auto gery-light"></Field>
                                <!-- <ErrorMessage
                                  name="contact_full_name"
                                  class="text-danger"
                                /> -->
                              </div>
                              <div class="col-md-8">
                                <label for="">Address</label>
                                <!-- <span class="text-danger">*</span> -->
                                <Field
                                  type="text"
                                  name="address"
                                  placeholder="Address"
                                  @keypress="
                                    $helperService.maxInput($event, 60)
                                  "
                                  v-model="detail.family_details.address"
                                  class="form-control h-auto gery-light"></Field>
                                <!-- <ErrorMessage
                                  name="address"
                                  class="text-danger"
                                /> -->
                              </div>
                              <div class="col-md-4 form-group">
                                <label for="">Area/Gaon</label>
                                <!-- <span class="text-danger">*</span> -->
                                <Field
                                  type="text"
                                  name="Area/Gaon"
                                  placeholder="Area/Gaon"
                                  @keypress="
                                    $helperService.maxInput($event, 20)
                                  "
                                  v-model="detail.family_details.goan"
                                  id=""
                                  rows="4"
                                  class="form-control h-auto gery-light"></Field>
                                <!-- <ErrorMessage
                                  name="Area/Gaon"
                                  class="text-danger"
                                /> -->
                              </div>
                              <div class="col-md-4 form-group">
                                <label for="">Taluka</label>
                                <!-- <span class="text-danger">*</span> -->
                                <div class="">
                                  <Field
                                    as="select"
                                    class="form-control gery-light"
                                    id="inputRole"
                                    name="taluka"
                                    v-model="detail.family_details.taluka_id">
                                    <option value="">Select Taluka</option>
                                    <option
                                      v-for="(data, index) in nativeTalukaList"
                                      :key="index"
                                      :value="data.uuid">
                                      {{ data.name }}
                                    </option>
                                  </Field>
                                  <!-- <ErrorMessage
                                    name="taluka"
                                    class="text-danger" /> -->
                                </div>
                              </div>
                              <div class="col-md-4 form-group">
                                <label for="">District</label>
                                <Field
                                  as="select"
                                  class="form-control gery-light"
                                  id="inputRole"
                                  name="district"
                                  v-model="detail.family_details.district_id">
                                  <option value="">Select District</option>
                                  <option
                                    v-for="(data, index) in districtList"
                                    :key="index"
                                    :value="data.uuid">
                                    {{ data.name }}
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="district"
                                  class="text-danger" />
                              </div>
                              <div class="col-md-4" style="display: none">
                                <label for="">State</label>
                                <Field
                                  as="select"
                                  class="form-control"
                                  id="inputRole"
                                  name="state"
                                  v-model="detail.family_details.state_id">
                                  <option value="">Select State</option>
                                  <option
                                    v-for="(data, index) in stateList"
                                    :key="index"
                                    :value="data.uuid">
                                    {{ data.name }}
                                  </option>
                                </Field>
                              </div>
                              <div class="col-6">
                                <label for="">Phone by Priority</label>
                                <!-- <span class="text-danger">*</span> -->
                                <div
                                  class="d-flex mb-2"
                                  v-for="(data, index) in detail.family_details
                                    .familty_phone_numbers"
                                  :key="index">
                                  <Field
                                    as="select"
                                    class="form-control mr-2 gery-light"
                                    :id="'inputRole_' + index"
                                    :name="'type_' + index"
                                    v-model="data.type">
                                    <option value="">Select</option>
                                    <option value="FATHER">Father</option>
                                    <option value="MOTHER">Mother</option>
                                    <option value="CANDIDATE">Candidate</option>
                                    <option value="BROTHER">Brother</option>
                                    <option value="SISTER">Sister</option>
                                    <option value="KAKA">Kaka</option>
                                    <option value="KAKI">Kaki</option>
                                    <option value="MAMA">Mama</option>
                                    <option value="MAMI">Mami</option>
                                    <option value="MAVSHI">Mavshi</option>
                                    <option value="AATTYA">Aattya</option>
                                    <option value="COUSIN_BROTHER">
                                      Cousin Brother
                                    </option>
                                    <option value="COUSINE_SISTER">
                                      Cousin Sister
                                    </option>
                                    <option value="FRIEND">Friend</option>
                                    <option value="OTHER">Other</option>
                                  </Field>
                                  <!-- <ErrorMessage
                                    :name="'type_' + index"
                                    class="text-danger"
                                  /> -->
                                  <div class="col-6">
                                    <Field
                                      type="text"
                                      class="form-control mr-2 gery-light"
                                      id="inputRole"
                                      :name="
                                        'family_phone_numbers_phone_' + index
                                      "
                                      v-model="data.phone"
                                      v-on:keypress="
                                        $helperService.allowOnlyNumericWithOperaterValue(
                                          $event
                                        )
                                      " />
                                  </div>
                                  <span
                                    :name="'whatsapp_' + index"
                                    v-on:click="updateWhatsappFlag(data)"
                                    :style="
                                      data.is_whatsapp == 'Y'
                                        ? 'opacity: 1'
                                        : 'opacity: 0.5'
                                    "
                                    class="h5 text-success mr-2 cursor-pointer"
                                    ><i class="bx bxl-whatsapp"></i
                                  ></span>
                                  <span
                                    :name="'phone_' + index"
                                    v-on:click="updateCallFlag(data)"
                                    :style="
                                      data.is_phone == 'Y'
                                        ? 'opacity: 1'
                                        : 'opacity: 0.5'
                                    "
                                    class="h5 cursor-pointer"
                                    ><i class="bx bxs-phone"></i
                                  ></span>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="form-group mt-3">
                                  <label for="">Mobile Number</label>
                                  <span class="text-danger">*</span>
                                  <Field
                                    type="text"
                                    name="phone"
                                    placeholder="Phone Number"
                                    v-slot="{ field }"
                                    v-model="detail.mobile"
                                    class="form-control mobile_no"
                                    rules="required:Mobile Number"
                                    :validateOnInput="true">
                                    <PhoneCode
                                      id="mobile"
                                      placeholder="Mobile Number"
                                      v-model:countryCode="detail.country_code"
                                      v-model="detail.mobile"
                                      v-model:dialCode="
                                        detail.mobile_country_code
                                      "
                                      v-bind="field" />
                                  </Field>
                                  <ErrorMessage
                                    name="phone"
                                    class="text-danger" />
                                </div>
                                <div class="form-group">
                                  <label>Email</label>
                                  <span class="text-danger">*</span>
                                  <Field
                                    style="background: #ddd"
                                    type="text"
                                    name="personal_email"
                                    class="form-control"
                                    placeholder="Email"
                                    v-model="detail.email"
                                    rules="required: Email|email"
                                    :validateOnInput="true" />
                                  <ErrorMessage
                                    name="personal_email"
                                    class="text-danger" />
                                </div>
                              </div>

                              <div class="col-12 form-group">
                                <label for="">Email Id</label>
                                <!-- <span class="text-danger">*</span> -->
                                <Field
                                  type="text"
                                  name="email"
                                  placeholder="Email id"
                                  @keypress="
                                    $helperService.maxInput($event, 32)
                                  "
                                  v-model="detail.family_details.email"
                                  class="form-control h-auto gery-light"></Field>
                                <!-- <ErrorMessage
                                  name="email"
                                  class="text-danger"
                                /> -->
                              </div>
                              <div class="col-6 form-group">
                                <label for="">Father Occupation</label>
                                <!-- <span class="text-danger">*</span> -->
                                <div class="row">
                                  <div class="col-6">
                                    <Field
                                      type="text"
                                      name="father_occupation"
                                      placeholder="Father Occupation"
                                      @keypress="
                                        $helperService.maxInput($event, 30)
                                      "
                                      v-model="
                                        detail.family_details.father_occuption
                                      "
                                      class="form-control"></Field>
                                    <!-- <ErrorMessage
                                      name="father_occupation"
                                      class="text-danger"
                                    /> -->
                                  </div>
                                  <div class="col-6">
                                    <Field
                                      type="text"
                                      name="occupation_place"
                                      placeholder="Occupation place"
                                      @keypress="
                                        $helperService.maxInput($event, 20)
                                      "
                                      v-model="
                                        detail.family_details
                                          .father_occuption_place
                                      "
                                      class="form-control h-auto gery-dark"></Field>
                                    <!-- <ErrorMessage
                                      name="occupation_place"
                                      class="text-danger"
                                    /> -->
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 mb-3">
                                <label for="">Mother Occupation</label>
                                <!-- <span class="text-danger">*</span> -->
                                <div class="row">
                                  <div class="col-6">
                                    <Field
                                      type="text"
                                      name="mother_occupation"
                                      placeholder="Mother Occupation"
                                      @keypress="
                                        $helperService.maxInput($event, 20)
                                      "
                                      v-model="
                                        detail.family_details.mother_occuption
                                      "
                                      class="form-control"></Field>
                                    <!-- <ErrorMessage
                                      name="mother_occupation"
                                      class="text-danger"
                                    /> -->
                                  </div>
                                  <div class="col-6">
                                    <Field
                                      type="text"
                                      name="mother_occupation_place"
                                      placeholder="Occupation place"
                                      @keypress="
                                        $helperService.maxInput($event, 20)
                                      "
                                      v-model="
                                        detail.family_details
                                          .mother_occuption_place
                                      "
                                      class="form-control h-auto gery-dark"></Field>
                                    <!-- <ErrorMessage
                                      name="mother_occupation_place"
                                      class="text-danger"
                                    /> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <div class="row mb-2">
                              <div
                                class="col-md-9"
                                v-if="
                                  detail.family_details.family_members != null
                                ">
                                <label for=""
                                  >Brother/Sister Details &nbsp;
                                  <span style="font-size: 12px"
                                    >(If sister is married, mention surname
                                    only)</span
                                  >
                                </label>
                              </div>
                              <div
                                class="col-md-3 text-right"
                                v-if="
                                  detail?.family_details?.family_members
                                    ?.length < 3
                                ">
                                <button
                                  type="button"
                                  v-on:click="showBrotherSisterPopup()"
                                  class="btn btn-primary"
                                  style="
                                    width: 74px;
                                    font-size: 14px;
                                    height: 36px;
                                    padding: 6px;
                                    right: 0;
                                  ">
                                  + Add
                                </button>
                              </div>
                            </div>

                            <div
                              class="table-responsive"
                              v-if="
                                detail.family_details.family_members != null
                              ">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th style="color: #db1c9c">Name</th>
                                    <th style="color: #db1c9c">Married?</th>
                                    <th style="color: #db1c9c">Education</th>
                                    <th style="color: #db1c9c">Occupation</th>
                                    <th style="color: #db1c9c">Place</th>
                                    <th style="color: #db1c9c">Birth Year</th>
                                    <th style="color: #db1c9c">Height</th>
                                    <th style="color: #db1c9c">Rel.</th>
                                    <th style="color: #db1c9c">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    class="gery-dark"
                                    v-for="(data, index) in detail
                                      .family_details.family_members"
                                    :key="index">
                                    <td>{{ data.name ? data.name : "-" }}</td>
                                    <td>
                                      {{
                                        data.is_married
                                          ? data.is_married == "Y"
                                            ? "Yes"
                                            : "No"
                                          : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.education ? data.education : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.occupation ? data.occupation : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.working_place
                                          ? data.working_place
                                          : "-"
                                      }}
                                    </td>

                                    <td>
                                      {{
                                        data.birth_year ? data.birth_year : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.height
                                          ? $helperService.getHeight(
                                              data.height
                                            )
                                          : "-"
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        data.gender
                                          ? data.gender == "M"
                                            ? "Bro"
                                            : "Sis"
                                          : "-"
                                      }}
                                    </td>
                                    <td>
                                      <a
                                        v-on:click="editBrotherSister(index)"
                                        href="javascript:void(0)"
                                        class="mr-2 text-dark"
                                        ><i class="bx bxs-edit-alt"></i
                                      ></a>
                                      <a
                                        v-on:click="removeBrotherSister(index)"
                                        class="mr-2 text-danger"
                                        ><i class="bx bx-trash"></i
                                      ></a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <label for="">Mama Surname</label>
                            <Field
                              type="text"
                              name="mama_surname"
                              @keypress="$helperService.maxInput($event, 25)"
                              placeholder="Mama Surname"
                              v-model="detail.family_details.mama_surname"
                              class="form-control mr-2"></Field>
                          </div>

                          <div class="col-md-4 mb-2">
                            <label for="">Mama Native Taluka</label>
                            <Field
                              type="text"
                              name="mama_taluka_place"
                              @keypress="$helperService.maxInput($event, 20)"
                              placeholder="Mama Native Taluka"
                              v-model="detail.family_details.mama_taluka_place"
                              class="form-control mr-2"></Field>
                            <!-- <ErrorMessage
                              name="mama_taluka_place"
                              class="text-danger"
                            /> -->
                          </div>

                          <div class="col-md-4 mb-2">
                            <label for="">Mama Native Gaon</label>
                            <Field
                              type="text"
                              name="mama_native_gaon"
                              @keypress="$helperService.maxInput($event, 20)"
                              placeholder="Mama Native Gaon"
                              v-model="detail.family_details.mama_native_place"
                              class="form-control mr-2 gery-dark"></Field>
                            <!-- <ErrorMessage
                              name="mama_taluka_place"
                              class="text-danger"
                            /> -->
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label for="">Relatives</label>
                          </div>
                          <div
                            class="col-md-6 d-flex mb-2"
                            v-for="(data, index) in detail.family_details
                              .relatives"
                            :key="index">
                            <Field
                              type="text"
                              class="form-control mr-2"
                              id="surname"
                              @keypress="$helperService.maxInput($event, 14)"
                              placeholder="Surname"
                              :name="'surname_' + index"
                              v-model="data.surname" />
                            <Field
                              type="text"
                              class="form-control mr-2 gery-dark"
                              id="goan"
                              @keypress="$helperService.maxInput($event, 14)"
                              placeholder="Gaon"
                              :name="'gaon_' + index"
                              v-model="data.goan" />
                          </div>
                          <div class="col-md-3 ml-2"></div>
                          <div class="col-md-3 ml-2">
                            <label for="">R</label>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="relationship"
                              v-model="detail.family_details.relationship_id">
                              <option value="">Select relation</option>
                              <option
                                v-for="(data, index) in relationListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>

                          <div class="col-md-4 ml-2">
                            <label for="">ES</label>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="echo_status"
                              v-model="detail.family_details.echo_status">
                              <option value="">Select eco status</option>
                              <option
                                v-for="(data, index) in echoStatusListNew"
                                :key="index"
                                :value="data.uuid">
                                {{ data.name }}
                              </option>
                            </Field>
                          </div>

                          <div class="col-md-4 ml-2">
                            <label for="">M.P</label>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="minus_point"
                              v-model="detail.family_details.minus_point">
                              <option value="">Select minus point</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </Field>
                          </div>
                        </div>
                      </div>
                      <div class="card-header py-2 bg-light border-top">
                        <p class="h5 mb-0 title-bld" style="color: blue">
                          Property Details
                        </p>
                      </div>
                      <div class="card-body">
                        <div class="row mb-1">
                          <div
                            class="col-md-10 bg-light py-1"
                            style="color: #db1c9c">
                            Properties, Flat, Land, Business, Vehicle Details
                          </div>
                          <div
                            class="col-md-2 bg-light py-1 px-1"
                            style="color: #db1c9c">
                            Property Place
                          </div>
                          <!-- <div class="col-md-2 bg-light text-right">
                            <button
                              type="button"
                              v-on:click="addVideoObj()"
                              class="btn btn-primary"
                              style="
                                width: 74px;
                                font-size: 14px;
                                height: 36px;
                                right: 0px;
                                margin-top: 2px;
                              ">
                              + Add
                            </button>
                          </div> -->
                        </div>
                        <div
                          class="row"
                          v-for="(data, index) in detail.user_properties"
                          :key="index">
                          <div class="col-12 mt-3 row">
                            <div class="col-lg-10 pr-0">
                              <Field
                                type="text"
                                class="form-control mr-2"
                                :id="'Name_' + index"
                                @keypress="$helperService.maxInput($event, 68)"
                                placeholder="Property Name"
                                :name="'Name_' + index"
                                v-model="data.details" />
                            </div>
                            <div class="col-lg-2 pr-0">
                              <Field
                                type="text"
                                class="form-control mr-2 gery-dark"
                                :id="'Details_' + index"
                                placeholder="Place"
                                :name="'Details_' + index"
                                @keypress="$helperService.maxInput($event, 10)"
                                v-model="data.place" />
                            </div>
                            <!-- <div class="col-lg-1">
                              <img
                                v-on:click="removevideoObj(data, index)"
                                src="/img/cross.png"
                                width="30"
                                height="30" />
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-2">
                            <label for="">First Payment Date</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              type="text"
                              name="opening_date"
                              placeholder="Select Date"
                              v-model="detail.opening_date"
                              v-slot="{ field }">
                              <Datepicker
                                autoApply
                                v-model="detail.opening_date"
                                inputFormat="dd-MM-yyyy"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                v-bind="field" />
                              <!-- <ErrorMessage
                                name="opening_date"
                                class="text-danger"
                              /> -->
                            </Field>
                          </div>
                          <div class="col-md-2" v-if="uuid">
                            <label for="">Latest Payment Date</label>

                            <Datepicker
                              autoApply
                              disabled
                              v-model="detail.payment_date"
                              inputFormat="dd-MM-yyyy"
                              format="dd-MM-yyyy"
                              placeholder="Select Date" />
                          </div>
                          <div class="col-md-2" v-if="uuid">
                            <label for=""> Total Amount Paid</label>
                            <!-- <span class="text-danger">*</span> -->
                            <Field
                              type="text"
                              disabled
                              name="latest_amount_paid"
                              placeholder="Latest Amount Paid"
                              v-model="detail.latest_amount_paid"
                              class="form-control"></Field>
                          </div>
                          <div class="col-md-2">
                            <label for="">From</label>
                            <Field
                              type="text"
                              name="user_source_from"
                              placeholder="From"
                              v-model="detail.user_source_from"
                              class="form-control mr-2"></Field>
                          </div>
                          <div class="col-md-3">
                            <label for="">Secret</label>
                            <Field
                              type="text"
                              name="secret_text"
                              placeholder="Secret Text"
                              v-model="detail.secret_text"
                              class="form-control mr-2"></Field>
                          </div>
                          <!-- <div class="col-md-1 pl-0">
                            <label for="">M.P.</label>
                            <Field
                              as="select"
                              class="form-control"
                              id="inputRole"
                              name="minus_point"
                              v-model="detail.minus_point"
                            >
                              <option value="" >Select</option>
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </Field>
                          </div> -->
                        </div>
                        <div class="row my-3">
                          <div class="col-md-2">
                            <label for="">Address & ID Proof</label>
                          </div>

                          <div class="col-md-4">
                            <button
                              type="button"
                              v-on:click="showIdProofPopup()"
                              class="btn btn-primary"
                              style="
                                width: 120px;
                                font-size: 14px;
                                height: 36px;
                                padding: 6px;
                              ">
                              Add ID Proof
                            </button>
                            <button
                              v-if="detail.user_documents"
                              type="button"
                              v-on:click="showIdProofPopup()"
                              class="btn btn-primary"
                              style="
                                width: 120px;
                                font-size: 14px;
                                height: 36px;
                                padding: 6px;
                                left: 0px;
                              ">
                              View ID Proof
                            </button>
                          </div>

                          <div class="col-md-2">
                            <!-- <div class="custom-control custom-switch mr-3">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="hide"
                                true-value="Y"
                                false-value="N"
                                v-model="detail.is_hidden"
                              />
                               <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="hide"
                                >Hide</label
                              >
                            </div> -->
                            <div class="custom-control custom-switch mr-3">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="admin_dont_share"
                                true-value="Y"
                                false-value="N"
                                v-model="detail.admin_dont_share" />
                              <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="admin_dont_share"
                                >Admin Dont Share</label
                              >
                            </div>
                            <!-- <div class="custom-control custom-switch mr-3">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="block"
                                true-value="Y"
                                false-value="N"
                                v-model="detail.block"
                              />
                           <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="block"
                                >Block</label
                              > 
                            </div> -->
                          </div>
                          <div class="col-lg-3">
                            <div class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="verify"
                                true-value="Y"
                                false-value="N"
                                v-model="detail.is_verified_mobile" />
                              <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="verify"
                                >Verify Contact Number</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <!-- <div class="col-md-3">
                            <label for="">Id Number</label>
                            <Field
                              type="text"
                              name="user_source_from"
                              placeholder="Id Number"
                              v-model="detail.user_source_from"
                              class="form-control mr-2"
                            ></Field>
                          </div> -->
                          <div class="col-md-6" style="display: none">
                            <div class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="verify"
                                true-value="Y"
                                false-value="N"
                                v-model="detail.is_verified_mobile" />
                              <label
                                class="custom-control-label mb-0"
                                style="line-height: inherit"
                                for="verify"
                                >Verify Contact Number</label
                              >
                            </div>
                          </div>

                          <div class="col-md-12 py-2 text-center">
                            <button
                              v-if="detail.status != 'DELETED' || !uuid"
                              id="save-button111"
                              class="btn btn-primary position-relative mr-2"
                              style="
                                width: 80px;
                                font-size: 14px;
                                height: 36px;
                                padding: 6px;
                                left: 0px;
                                display: inline-block;
                                margin-top: 0px;
                              ">
                              Save
                            </button>
                            <button
                              v-on:click="redirectTo()"
                              type="button"
                              class="btn position-relative"
                              style="
                                width: 80px;
                                font-size: 14px;
                                height: 35px;
                                padding: 6px;
                                left: 0px;
                                display: inline-block;
                                background: transparent;
                                border: 1px solid #dc3545;
                                color: #dc3545;
                              "
                              id="cancel-button">
                              Cancel
                            </button>
                            <button
                              v-if="uuid"
                              type="button"
                              class="btn position-relative ml-2"
                              style="
                                width: 180px;
                                font-size: 14px;
                                height: 35px;
                                padding: 6px;
                                left: 0px;
                                display: inline-block;
                                background: transparent;
                                border: 1px solid #dc3545;
                                color: #dc3545;
                              "
                              v-on:click="importFamilyDetail()">
                              Import Family Detail
                            </button>
                            <button
                              v-if="uuid && detail.status == 'DELETED'"
                              type="button"
                              class="btn position-relative ml-2"
                              style="
                                width: 200px;
                                font-size: 14px;
                                height: 35px;
                                padding: 6px;
                                left: 0px;
                                display: inline-block;
                                background: transparent;
                                border: 1px solid #dc3545;
                                color: #dc3545;
                              "
                              v-on:click="moveToMemberList()">
                              Move to Member List
                            </button>
                            <button
                              v-if="uuid && detail.status != 'DELETED'"
                              type="button"
                              class="btn position-relative ml-2"
                              style="
                                width: 200px;
                                font-size: 14px;
                                height: 35px;
                                padding: 6px;
                                left: 0px;
                                display: inline-block;
                                background: transparent;
                                border: 1px solid #dc3545;
                                color: #dc3545;
                              "
                              v-on:click="moveToMarried()">
                              Move to Married
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <ErrorComponent @retry="getDetail()" ref="errorComponent" />
    </div>
    <!-- kjb -->
    <TextModal ref="textModal">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ detail.uuid ? "View" : "Upload" }} Address & ID Proof
        </h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.textModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="IdForm" @submit="saveIdProof()">
        <div class="modal-body">
          <div class="form-group col-lg-12">
            <p class="font-medium text-uppercase" style="color: #f11919">
              Please Select any one from below For address & ID Proof
            </p>
            <label for="inputRole">ID proof</label>
            <span class="text-danger">*</span>
            <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="name_country"
              v-model="documentDetail.type"
              v-on:change="uploadnewDocuemnt(documentDetail.type)"
              rules="required:id proof">
              <option value="">Select ID proof</option>
              <option value="AADHAR">Aadhar Card</option>
              <option value="LICENCE">Driving License</option>
              <option value="PANCARD">PAN Card</option>
              <option value="PASSPORT">Passport</option>
              <option value="VOTER_ID">Voter ID</option>
            </Field>
            <ErrorMessage name="name_country" class="text-danger" />
          </div>
          <!-- <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>ID number </label>
              <span class="text-danger">*</span>
              <Field
                type="text"
                class="form-control"
                name="id_number"
                v-model="documentDetail.id_number"
                placeholder="ID number"
                rules="required:id number"
                :validateOnInput="true"
              />
              <ErrorMessage name="id_number" class="text-danger" />
            </div>
          </div> -->
          <div class="col-lg-12 col-sm-12 mb-3 row">
            <div class="col-md-6 mb-4">
              <DocumentPicker
                :src="
                  documentDetail.front_image ? documentDetail.front_image : ''
                "
                :uuid="documentDetail.uuid"
                :file_name="documentDetail.front_file_name"
                :type="'FRONT_IMAGE'"
                ref="documentFrontImage"
                @removeDocument="showpopup($event)" />
            </div>
            <div class="col-md-6 mb-4">
              <DocumentPicker
                :src="
                  documentDetail.back_image ? documentDetail.back_image : ''
                "
                :uuid="documentDetail.uuid"
                :type="'BACK_IMAGE'"
                :file_name="documentDetail.back_file_name"
                ref="documentBackImage"
                @removeDocument="showpopup($event)" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="save-document" class="fill-btn">Save</button>
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.textModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>
    <!-- ------------------->
    <TextModal ref="BrotherSisterModal">
      <div class="modal-header">
        <h5 class="modal-title"><b>Add Brother/Sister Details</b></h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.BrotherSisterModal.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="BrotherSisterForm" @submit="saveBrotherSister()">
        <div class="modal-body">
          <div class="col-lg-12 col-sm-12 row">
            <div class="col-lg-12">
              <!-- <span style="font-size: 12px; font-weight: bold"
                >if Sister is married, Mention surname only</span
              > -->
            </div>
            <div class="col-lg-12">
              <div class="form-group">
                <label for="name">First Name</label>
                &nbsp;
                <span style="font-size: 12px; font-weight: bold"
                  >(If sister is married, mention surname only)</span
                >
                <Field
                  type="text"
                  class="form-control"
                  name="name"
                  @keypress="$helperService.maxInput($event, 14)"
                  v-model="brotherSisterObj.name"
                  placeholder="First Name"
                  autofocus="true" />
              </div>
            </div>

            <div class="form-group col-lg-12">
              <label for="inputRole">Married?</label>
              <Field
                as="select"
                class="form-control"
                id="inputRole"
                name="is_married"
                v-model="brotherSisterObj.is_married">
                <option value="">Select Status</option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </Field>
            </div>
          </div>

          <div class="col-lg-12 col-sm-12 row">
            <div class="form-group col-lg-6">
              <label>Education</label>
              <Field
                type="text"
                class="form-control"
                @keypress="$helperService.maxInput($event, 20)"
                name="education"
                v-model="brotherSisterObj.education"
                placeholder="Education" />
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>Occupation</label>
                <Field
                  type="text"
                  class="form-control"
                  @keypress="$helperService.maxInput($event, 19)"
                  name="occupation"
                  v-model="brotherSisterObj.occupation"
                  placeholder="Occupation" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>Working Place</label>
              <Field
                type="text"
                class="form-control"
                name="working_place"
                @keypress="$helperService.maxInput($event, 17)"
                v-model="brotherSisterObj.working_place"
                placeholder="Working Place" />
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <div class="form-group">
              <label>Birth Year</label>

              <Field
                type="text"
                name="birth_year"
                placeholder="Select date of birth"
                v-model="brotherSisterObj.birth_year"
                v-slot="{ field }">
                <Datepicker
                  autoApply
                  v-model="brotherSisterObj.birth_year"
                  inputFormat="dd-MM-yyyy"
                  format="yyyy"
                  placeholder="Select Year"
                  :maxDate="new Date()"
                  v-bind="field"
                  yearPicker />
              </Field>
            </div>
          </div>
          <div class="col-lg-12 col-sm-12">
            <label for="">Height</label>
            <!-- <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="height"
              v-model="brotherSisterObj.height"
            >
              <option value="" >Select Height</option>
              <option value="139">
                {{ $helperService.getHeight(139) }}-139cm
              </option>
              <option value="142">
                {{ $helperService.getHeight(142) }}-142cm
              </option>
              <option value="144">
                {{ $helperService.getHeight(144) }}-144cm
              </option>
              <option value="147">
                {{ $helperService.getHeight(147) }}-147cm
              </option>
              <option value="149">
                {{ $helperService.getHeight(149) }}-149cm
              </option>
              <option value="152">
                {{ $helperService.getHeight(152) }}-152cm
              </option>
              <option value="154">
                {{ $helperService.getHeight(154) }}-154cm
              </option>
              <option value="157">
                {{ $helperService.getHeight(157) }}-157cm
              </option>
              <option value="160">
                {{ $helperService.getHeight(160) }}-160cm
              </option>
              <option value="162">
                {{ $helperService.getHeight(162) }}-162cm
              </option>
              <option value="165">
                {{ $helperService.getHeight(165) }}-165cm
              </option>
              <option value="167">
                {{ $helperService.getHeight(167) }}-167cm
              </option>
              <option value="170">
                {{ $helperService.getHeight(170) }}-170cm
              </option>
              <option value="172">
                {{ $helperService.getHeight(172) }}-172cm
              </option>
              <option value="175">
                {{ $helperService.getHeight(175) }}-175cm
              </option>
              <option value="177">
                {{ $helperService.getHeight(177) }}-177cm
              </option>
              <option value="180">
                {{ $helperService.getHeight(180) }}-180cm
              </option>
              <option value="182">
                {{ $helperService.getHeight(182) }}-182cm
              </option>
              <option value="185">
                {{ $helperService.getHeight(185) }}-185cm
              </option>
              <option value="187">
                {{ $helperService.getHeight(187) }}-187cm
              </option>
              <option value="190">
                {{ $helperService.getHeight(190) }}-190cm
              </option>
              <option value="192">
                {{ $helperService.getHeight(192) }}-192cm
              </option>
              <option value="195">
                {{ $helperService.getHeight(195) }}-195cm
              </option>
              <option value="198">
                {{ $helperService.getHeight(198) }}-198cm
              </option>
              <option value="200">
                {{ $helperService.getHeight(200) }}-200cm
              </option>
              <option value="203">
                {{ $helperService.getHeight(203) }}-203cm
              </option>
              <option value="205">
                {{ $helperService.getHeight(205) }}-205cm
              </option>
              <option value="208">
                {{ $helperService.getHeight(208) }}-208cm
              </option>
              <option value="210">
                {{ $helperService.getHeight(210) }}-210cm
              </option>
              <option value="213">
                {{ $helperService.getHeight(213) }}-213cm
              </option>
            </Field> -->
            <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="height"
              v-model="brotherSisterObj.height">
              <option value="">Select Height</option>
              <option value="139">
                {{ $helperService.getHeight(139) }}
              </option>
              <option value="142">
                {{ $helperService.getHeight(142) }}
              </option>
              <option value="144">
                {{ $helperService.getHeight(144) }}
              </option>
              <option value="147">
                {{ $helperService.getHeight(147) }}
              </option>
              <option value="149">
                {{ $helperService.getHeight(149) }}
              </option>
              <option value="152">
                {{ $helperService.getHeight(152) }}
              </option>
              <option value="154">
                {{ $helperService.getHeight(154) }}
              </option>
              <option value="157">
                {{ $helperService.getHeight(157) }}
              </option>
              <option value="160">
                {{ $helperService.getHeight(160) }}
              </option>
              <option value="162">
                {{ $helperService.getHeight(162) }}
              </option>
              <option value="165">
                {{ $helperService.getHeight(165) }}
              </option>
              <option value="167">
                {{ $helperService.getHeight(167) }}
              </option>
              <option value="170">
                {{ $helperService.getHeight(170) }}
              </option>
              <option value="172">
                {{ $helperService.getHeight(172) }}
              </option>
              <option value="175">
                {{ $helperService.getHeight(175) }}
              </option>
              <option value="177">
                {{ $helperService.getHeight(177) }}
              </option>
              <option value="180">
                {{ $helperService.getHeight(180) }}
              </option>
              <option value="182">
                {{ $helperService.getHeight(182) }}
              </option>
              <option value="185">
                {{ $helperService.getHeight(185) }}
              </option>
              <option value="187">
                {{ $helperService.getHeight(187) }}
              </option>
              <option value="190">
                {{ $helperService.getHeight(190) }}
              </option>
              <option value="192">
                {{ $helperService.getHeight(192) }}
              </option>
              <option value="195">
                {{ $helperService.getHeight(195) }}
              </option>
              <option value="198">
                {{ $helperService.getHeight(198) }}
              </option>
              <option value="200">
                {{ $helperService.getHeight(200) }}
              </option>
              <option value="203">
                {{ $helperService.getHeight(203) }}
              </option>
              <option value="205">
                {{ $helperService.getHeight(205) }}
              </option>
              <option value="208">
                {{ $helperService.getHeight(208) }}
              </option>
              <option value="210">
                {{ $helperService.getHeight(210) }}
              </option>
              <option value="213">
                {{ $helperService.getHeight(213) }}
              </option>
            </Field>
          </div>
          <div class="col-md-12 mb-2 mt-1">
            <label for="">Rel.</label>

            <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="genderType"
              v-model="brotherSisterObj.gender">
              <option value="">Select Rel.</option>
              <option value="M">Bro</option>
              <option value="F">Sis</option>
            </Field>
          </div>
        </div>
        <div class="modal-footer">
          <button id="Brother_Sister" class="fill-btn">Save</button>
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.BrotherSisterModal.closeModal">
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>
    <DeleteModal
      @remove="removeImage(this.image_uuid, this.index)"
      ref="deleteModal" />

    <TextModal ref="confirmationPopup">
      <div class="modal-header">
        <h5 class="modal-title">Delete Document</h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.confirmationPopup.closeModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="IdForm" @submit="remooveDocument()">
        <div class="modal-body">
          <div class="form-group col-lg-12">
            <p class="font-medium text-uppercase" style="color: #f11919">
              Are you sure want to remove Document ?
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button id="remooveDocument-document" class="fill-btn">Yes</button>
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.confirmationPopup.closeModal">
            No
          </button>
        </div>
      </Form>
    </TextModal>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import Multiselect from "@vueform/multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import TextModal from "@/components/TextModal";
import "@vuepic/vue-datepicker/dist/main.css";
import ProductImagePicker from "../../components/ProductImagePicker.vue";
import CustomDatepicker from "@/components/DatePicker.vue";
import DocumentPicker from "@/components/DocumentPicker.vue";
import moment from "moment";
import DeleteModal from "@/components/DeleteModal";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode.vue";
// import { thisExpression } from "@babel/types";
// import MiniCssExtractPlugin from "mini-css-extract-plugin";
export default {
  name: "AddUser",
  components: {
    Form,
    Field,
    ErrorMessage,
    DeleteModal,
    DocumentPicker,
    CustomDatepicker,
    ErrorComponent,
    Multiselect,
    ProductImagePicker,
    TextModal,
    Datepicker,
    PhoneCode,
  },
  data() {
    return {
      new_uuid: "",
      new_type: "",
      image_limit: 5,
      documentDetail: {
        type: "LICENCE",
      },
      myArr: [],
      image_uuid: "",
      index: "",
      currentTab: "",
      uuid: this.$route.params.uuid,
      type: this.$route.params.type,
      brotherSisterObj: {
        name: "",
        is_married: "",
        education: "",
        occupation: "",
        working_place: "",
        birth_year: "",
        height: "",
        gender: "",
        indx: null,
      },
      detail: {
        user_properties: [{}, {}, {}, {}],
        brotherSisterObj: {},
        is_mangal: "",
        document_id: "",
        user_images: [{ image_id: 0 }, { image_id: 1 }],
        birth_district_id: "",
        images: [],
        type: "",
        id_number: "",
        blood_group: "",
        membership_plan_id: "",
        marital_status_id: "",
        native_place_taluka_id: "",
        native_place_district_id: "",
        height: "",
        body_structure_id: "",
        scan_tone_id: "",
        diet_id: "",
        education_group_id: "",
        personality_id: "",
        occupation_type_id: "",
        working_place_country_id: "",
        working_place_state_id: "",
        working_place_district_id: "",
        working_place_taluka_id: "",
        raas_id: "",
        nakshatra_id: "",
        charan_id: "",
        nadi_id: "",
        gan_id: "",
        ready_to_move_abrod: "",
        dob: "",
        is_hidden: "N",
        admin_dont_share: "N",
        block: "N",
        is_verified_mobile: "N",
        family_details: {
          family_members: [],
          familty_phone_numbers: [
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
            {
              type: "",
              phone: "",
              custom_type_name: "",
              is_whatsapp: "N",
              is_phone: "N",
            },
          ],
          relatives: [
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
            {
              surname: "",
              goan: "",
            },
          ],
        },
        expectation: {
          move_to_abroad: [],
          same_devak: "N",
          birth_year_from: "",
          birth_year_to: "",
          height_from: "",
          height_to: "",
          expected_educations: "",
          occupation_other_expectations: "",
          marital_status: [],
          mangal: [],
          occupation_type: [],
          body_structure: [],
          diet: [],
          education_group: [],
          working_city: [],
          native_district: [],
          native_taluka: [],
          family_residence: [],
          working_country: [],
          personality: [],
          relation: [],
          echo_status: [],
        },
        user_document: [],
      },
      membershipPlanList: [],
      marriedStatusList: [{ name: "Select All", uuid: "" }],

      marriedStatusListNew: [],
      devakList: [],
      nativeTalukaList: [],
      worklocationList: [],
      districtList: [],
      countryList: [],
      bodyStructureListNew: [],
      bodyStructureList: [{ name: "Select All", uuid: "" }],
      skintoneList: [],
      dietListNew: [],
      dietList: [{ name: "Select All", uuid: "" }],
      educationGroupList: [{ name: "Select All", uuid: "" }],
      occupationTypeList: [{ name: "Select All", uuid: "" }],
      occupationTypeListNew: [],
      educationGroupListNew: [],
      stateList: [],
      rashiList: [],
      nakshtraList: [],
      charanList: [],
      nadiList: [],
      ganList: [],
      relationListNew: [],
      relationList: [{ name: "Select All", uuid: "" }],
      personalityList: [{ name: "Select All", uuid: "" }],
      personalityListNew: [],
      echoStatusListNew: [],
      moveToAbroadListNew: [],
      echoStatusList: [{ name: "Select All", uuid: "" }],
      moveToAbroadList: [{ name: "Select All", uuid: "" }],
      mangalList: [
        { name: "Select All", uuid: "Select All" },
        { name: "Yes", uuid: "Y" },
        { name: "No", uuid: "N" },
        { name: "Soumya", uuid: "SOUMYA" },
        { name: "Nirdosh", uuid: "NIRDOSH" },
        { name: "Not Known", uuid: "NOT_KNOWN" },
        { name: "NO,", uuid: "NO," },
      ],
    };
  },
  mounted() {
    this.$helperService.showMenu("false");
    this.getMembershipPlanList();
    this.getStatusList("DEVAK");
    this.getStatusList("MARITAL_STATUS");
    this.getStatusList("BODY_STRUCTURE");
    this.getStatusList("SKIN_TONE");
    this.getStatusList("DIET");
    this.getStatusList("EDUCATION_GROUP");
    this.getStatusList("OCCUPATION_TYPE");
    this.getStatusList("RAAS");
    this.getStatusList("NAKSHTRA");
    this.getStatusList("NADI");
    this.getStatusList("GAN");
    this.getStatusList("RELATION");
    this.getStatusList("ECO_STATUS");
    this.getStatusList("PERSONALITY");
    this.getStatusList("MOVE_TO_ABROAD");
    this.getStatusList("CHARAN");
    this.getTalukaList();
    this.getWorkLocationList();
    this.getDistrictList();
    this.getCountryList();
    this.getStateList();
    if (this.uuid) {
      this.getDetail();
    }
    this.changeTab("BASIC_INFO");
  },
  methods: {
    getCharan(nakshatra_id) {
      this.getStatusList("CHARAN", nakshatra_id);
    },
    redirectTo() {
      if (localStorage.getItem("tab_type") == "MARRIED") {
        this.$router.push("/married-list/HIDE");
      } else {
        this.$router.push("/member-list/HIDE");
      }
    },
    SelectAllDietList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.dietList.length; i++) {
          var obj = this.dietList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.diet = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.diet = [];
        for (var j in this.dietList) {
          if (this.dietList[j].name == "Deselect All") {
            this.dietList[j].name = "Select All";
          }
        }
      }
    },
    SelectAllEducationList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.educationGroupList.length; i++) {
          var obj = this.educationGroupList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.education_group = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.education_group = [];
        for (var j in this.educationGroupList) {
          if (this.educationGroupList[j].name == "Deselect All") {
            this.educationGroupList[j].name = "Select All";
          }
        }
      }
    },
    SelectAllOcupationList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.occupationTypeList.length; i++) {
          var obj = this.occupationTypeList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.occupation_type = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.occupation_type = [];
        for (var j in this.occupationTypeList) {
          if (this.occupationTypeList[j].name == "Deselect All") {
            this.occupationTypeList[j].name = "Select All";
          }
        }
      }
    },
    uploadnewDocuemnt(type) {
      this.documentDetail.back_image = "";
      this.documentDetail.front_image = "";
      this.documentDetail.id_number = "";
      this.$refs.documentFrontImage.selectFile = null;
      this.$refs.documentBackImage.selectFile = null;
      this.$refs.documentFrontImage.url = null;
      this.$refs.documentBackImage.url = null;
      this.$refs.documentFrontImage.file_type = null;
      this.$refs.documentBackImage.file_type = null;

      this.isChecked = false;
      this.getDoumentDetail(type);
    },
    SelectAllrelationList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.relationList.length; i++) {
          var obj = this.relationList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.relation = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.relation = [];
        for (var j in this.relationList) {
          if (this.relationList[j].name == "Deselect All") {
            this.relationList[j].name = "Select All";
          }
        }
      }
    },
    SelectAllpersonalityList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.personalityList.length; i++) {
          var obj = this.personalityList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.personality = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.personality = [];
        for (var p in this.personalityList) {
          if (this.personalityList[p].name == "Deselect All") {
            this.personalityList[p].name = "Select All";
          }
        }
      }
    },
    SelectAllMarriedList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.marriedStatusList.length; i++) {
          var obj = this.marriedStatusList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.marital_status = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.marital_status = [];
        for (var j in this.marriedStatusList) {
          if (this.marriedStatusList[j].name == "Deselect All") {
            this.marriedStatusList[j].name = "Select All";
          }
        }
      }
    },

    SelectAllBoadyStructureList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.bodyStructureList.length; i++) {
          var obj = this.bodyStructureList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.body_structure = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.body_structure = [];
        for (var j in this.bodyStructureList) {
          if (this.bodyStructureList[j].name == "Deselect All") {
            this.bodyStructureList[j].name = "Select All";
          }
        }
      }
    },

    SelectAllMoveToAbroadList(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.moveToAbroadList.length; i++) {
          var obj = this.moveToAbroadList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.move_to_abroad = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.move_to_abroad = [];
        for (var j in this.moveToAbroadList) {
          if (this.moveToAbroadList[j].name == "Deselect All") {
            this.moveToAbroadList[j].name = "Select All";
          }
        }
      }
    },
    SelectAllMangal(e) {
      console.log("e", e);
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.mangalList.length; i++) {
          var obj = this.mangalList[i];
          if (obj.name != "Select All") {
            temp.push(obj.uuid);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.expectation.mangal = temp;
      } else if (e == "Deselect All") {
        this.detail.expectation.mangal = [];
        for (var j in this.mangalList) {
          if (this.mangalList[j].name == "Deselect All") {
            this.mangalList[j].name = "Select All";
            this.mangalList[j].uuid = "Select All";
          }
        }
      }
    },
    SelectAllEcho(e) {
      var temp = [];
      if (e.name == "Select All") {
        for (var i = 0; i < this.echoStatusList.length; i++) {
          var obj = this.echoStatusList[i];
          if (obj.name != "Select All") {
            temp.push(obj);
          } else {
            obj.name = "Deselect All";
          }
        }
        this.detail.expectation.echo_status = temp;
      } else if (e.name == "Deselect All") {
        this.detail.expectation.echo_status = [];
        for (var j in this.echoStatusList) {
          if (this.echoStatusList[j].name == "Deselect All") {
            this.echoStatusList[j].name = "Select All";
          }
        }
      }
    },

    saveBrotherSister() {
      var obj = {
        name: this.brotherSisterObj.name,
        is_married: this.brotherSisterObj.is_married,
        education: this.brotherSisterObj.education,
        occupation: this.brotherSisterObj.occupation,
        working_place: this.brotherSisterObj.working_place,
        birth_year: this.brotherSisterObj.birth_year,
        height: this.brotherSisterObj.height,
        gender: this.brotherSisterObj.gender,
        indx: null,
      };
      if (this.brotherSisterObj.indx != null) {
        for (var i in this.detail.family_details.family_members) {
          if (i == this.brotherSisterObj.indx) {
            this.detail.family_details.family_members[i] =
              this.brotherSisterObj;
          }
        }
        this.brotherSisterObj.indx = null;
      } else {
        this.detail.family_details.family_members.push(obj);
      }

      this.$refs.BrotherSisterModal.closeModal();
    },
    removeBrotherSister(index) {
      this.detail.family_details.family_members.splice(index, 1);
    },
    editBrotherSister(index) {
      var obj = {
        name: this.detail.family_details.family_members[index].name,
        is_married: this.detail.family_details.family_members[index].is_married,
        education: this.detail.family_details.family_members[index].education,
        occupation: this.detail.family_details.family_members[index].occupation,
        working_place:
          this.detail.family_details.family_members[index].working_place,
        birth_year: this.detail.family_details.family_members[index].birth_year,
        height: this.detail.family_details.family_members[index].height,
        gender: this.detail.family_details.family_members[index].gender,
        indx: index,
      };
      this.brotherSisterObj = obj;
      this.$refs.BrotherSisterModal.showModal();
    },

    changeBOD(e) {
      var date = new Proxy(e, {}).date;
      this.detail.dob = date.format("YYYY-MM-DD");
    },

    showpopup(e) {
      this.new_uuid = e.uuid;
      this.new_type = e.type;
      this.$refs.confirmationPopup.showModal();
    },
    remooveDocument() {
      if (this.new_uuid) {
        this.$api
          .putAPI({
            _action: "/remove-document",
            _body: {
              uuid: this.new_uuid,
              type: this.new_type,
            },
            _buttonId: "remooveDocument-document",
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getDoumentDetail();
            this.$refs.confirmationPopup.closeModal();
          })
          .catch(() => {});
      }
      //  else {
      //   this.detail.user_images.splice(index, 1);
      //   console.log("this.detail.user_images after", index);
      // }
    },
    importFamilyDetail() {
      this.$router.push("/add-user");
      this.uuid = null;
      this.detail.expectation = {
        move_to_abroad: [],
        birth_year_from: "",
        birth_year_to: "",
        height_from: "",
        height_to: "",
        expected_educations: "",
        occupation_other_expectations: "",
        marital_status: [],
        mangal: [],
        occupation_type: [],
        body_structure: [],
        diet: [],
        education_group: [],
        working_city: [],
        native_district: [],
        native_taluka: [],
        family_residence: [],
        working_country: [],
        personality: [],
        relation: [],
        echo_status: [],
      };
      this.detail.first_name = "";
      this.detail.middle_name = "";
      this.detail.dob = "";
      this.detail.marital_status_id = "";
      this.detail.registration_no = "";
      this.detail.gender = "";
      this.detail.last_name = "";
      this.detail.middle_name = "";
      this.detail.native_place_goan = "";
      this.detail.native_place_taluka_id = "";
      this.detail.native_place_district_id = "";
      this.detail.height = "";
      this.detail.body_structure_id = "";
      this.detail.blood_group = "";
      this.detail.scan_tone_id = "";
      this.detail.diet_id = "";
      this.detail.education_courses = "";
      this.detail.education_group_id = "";
      this.detail.personality_id = "";
      this.detail.occupation_type_id = "";
      this.detail.occupation_details = "";
      this.detail.annual_income = "";
      this.detail.working_place_country_id = "";
      this.detail.working_place_state_id = "";
      this.detail.working_place_district_id = "";
      this.detail.working_place_taluka_id = "";
      this.detail.working_place_goan = "";
      this.detail.other_info = "";
      this.detail.birth_time = "";
      this.detail.birth_district_id = "";
      this.detail.gun = "";
      this.detail.is_mangal = "";
      this.detail.raas_id = "";
      this.detail.nakshatra_id = "";
      this.detail.charan_id = "";
      this.detail.nadi_id = "";
      this.detail.gan_id = "";
      this.detail.devak = "";
      this.detail.ready_to_move_abrod = "";
      this.detail.user_images = [{ image_id: 0 }, { image_id: 1 }];
      this.user_document = [{}];
    },

    getDoumentDetail(type) {
      if (this.detail.document_id) {
        this.documentDetail.uuid = this.detail.document_id;
      }
      if (this.uuid) {
        this.$api
          .getAPI({
            _action: "/document/detail/" + this.uuid,
          })
          .then((res) => {
            if (res) {
              if (type == res.type) {
                this.documentDetail = res;
              }

              if (!type) {
                this.documentDetail = res;
              }
            }
          })
          .catch(() => {});
      }
    },
    addImage(e, index) {
      // var add_new_block = new Proxy(e, {}).add_new_block;
      // if (this.detail.user_images.length < 5 && add_new_block) {
      // var id = this.detail.user_images.length;
      // if (id == 0) {
      //   id = 1;
      // } else if (id == 1) {
      //   id = 2;
      // } else if (id == 2) {
      //   id = 3;
      // } else if (id == 3) {
      //   id = 4;
      // }

      this.detail.user_images[index].image = e.image.src;
      // if (id <= 4) {

      // if (this.detail.user_images.length < 2) {
      //   this.detail.user_images.push({
      //     image_id: id + 1,
      //   });
      // }

      // }
      // }
    },
    updateImage(e, index) {
      for (var i in this.detail.user_images) {
        if (index == i) {
          this.detail.user_images[i].image = e.image.src;
        }
      }
    },
    showremoveImagePopup(data, index) {
      this.$refs.deleteModal.removeLoader();
      this.index = index;
      this.image_uuid = data.uuid;
      this.$refs.deleteModal.showModal(
        "Remove Image",
        "Are you sure you want to remove Image",
        data
      );
    },
    removeImage(uuid, index) {
      // console.log("this.detail.user_images Before", this.detail.user_images);
      // alert(this.detail.user_images[index].image);
      if (uuid) {
        this.$api
          .deleteAPI({
            _action: "/remove-image/" + uuid,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$refs.deleteModal.closeModal();
            this.getDetail();
          })
          .catch(() => {});
      } else {
        this.detail.user_images[index].image = "";
        // this.detail.user_images.push({
        //   image_id: index,
        // });
        this.$refs.deleteModal.closeModal();
        // }
        // console.log("this.detail.user_images after", index);
      }
    },
    removevideoObj(data, index) {
      if (data.uuid) {
        this.$api
          .deleteAPI({
            _action: "/remove-property/" + data.uuid,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getDetail();
          })
          .catch(() => {});
      } else {
        this.detail.user_properties.splice(index, 1);
      }
    },
    addVideoObj() {
      this.detail.user_properties.push({});
    },
    getDetail() {
      this.$refs.saved.resetForm();
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/details/user/" + this.uuid,
        })
        .then((res) => {
          if (!res.family_details) {
            res.family_details = {
              family_members: [],
              familty_phone_numbers: [
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
                {
                  type: "",
                  phone: "",
                  custom_type_name: "",
                  is_whatsapp: "N",
                  is_phone: "N",
                },
              ],
              relatives: [
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
                {
                  surname: "",
                  goan: "",
                },
              ],
            };
          }
          if (res.user_properties.length < 4) {
            const length = res.user_properties.length;
            for (var qq = 0; qq < 4 - length; qq++) {
              res.user_properties.push({
                details: "",
                place: "",
              });
            }
          }
          if (res.family_details && res.family_details.relatives.length == 0) {
            res.family_details.relatives = [
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
              {
                surname: "",
                goan: "",
              },
            ];
          }

          if (res.family_details && res.family_details.relatives.length > 0) {
            var length = 5 - res.family_details.relatives.length;
            if (length > 0) {
              for (var i = 0; i < length; i++) {
                res.family_details.relatives.push({
                  surname: "",
                  goan: "",
                });
              }
            }
          }
          if (res.family_details && res.family_details.relatives.length > 5) {
            for (var z in res.family_details.relatives) {
              if (z > 4) {
                res.family_details.relatives.splice(1, z);
              }
            }
          }

          if (res.birth_time) {
            var time = res.birth_time.split(":");
            res.birth_time = {
              hours: time[0],
              minutes: time[1],
              seconds: time[2],
            };
          }
          if (!res.expectation || res.expectation == null) {
            res.expectation = {
              move_to_abroad: [],
              birth_year_from: "",
              birth_year_to: "",
              height_from: "",
              height_to: "",
              expected_educations: "",
              occupation_other_expectations: "",
              marital_status: [],
              mangal: [],
              occupation_type: [],
              body_structure: [],
              diet: [],
              education_group: [],
              working_city: [],
              native_district: [],
              native_taluka: [],
              family_residence: [],
              working_country: [],
              personality: [],
              relation: [],
              echo_status: [],
            };
          }
          this.detail = res;

          if (
            this.detail.expectation &&
            this.detail.expectation.marital_status.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.marital_status.length ==
                this.marriedStatusList.length - 1
            ) {
              for (var j in this.marriedStatusList) {
                if (this.marriedStatusList[j].name == "Select All") {
                  this.marriedStatusList[j].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.mangal.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.mangal.length ==
                this.mangalList.length - 1
            ) {
              for (var e in this.mangalList) {
                if (this.mangalList[e].uuid == "Select All") {
                  this.mangalList[e].name = "Deselect All";
                  this.mangalList[e].uuid = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.occupation_type.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.occupation_type.length ==
                this.occupationTypeList.length - 1
            ) {
              for (var k in this.occupationTypeList) {
                if (this.occupationTypeList[k].name == "Select All") {
                  this.occupationTypeList[k].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.body_structure.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.body_structure.length ==
                this.bodyStructureList.length - 1
            ) {
              for (var l in this.bodyStructureList) {
                if (this.bodyStructureList[l].name == "Select All") {
                  this.bodyStructureList[l].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.diet.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.diet.length == this.dietList.length - 1
            ) {
              for (var m in this.dietList) {
                if (this.dietList[m].name == "Select All") {
                  this.dietList[m].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.education_group.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.education_group.length ==
                this.educationGroupList.length - 1
            ) {
              for (var n in this.educationGroupList) {
                if (this.educationGroupList[n].name == "Select All") {
                  this.educationGroupList[n].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.relation.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.relation.length ==
                this.relationList.length - 1
            ) {
              for (var r in this.relationList) {
                if (this.relationList[r].name == "Select All") {
                  this.relationList[r].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.move_to_abroad.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.move_to_abroad.length ==
                this.moveToAbroadList.length - 1
            ) {
              for (var p in this.moveToAbroadList) {
                if (this.moveToAbroadList[p].name == "Select All") {
                  this.moveToAbroadList[p].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.echo_status.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.echo_status.length ==
                this.echoStatusList.length - 1
            ) {
              for (var b in this.echoStatusList) {
                if (this.echoStatusList[b].name == "Select All") {
                  this.echoStatusList[b].name = "Deselect All";
                }
              }
            }
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.personality.length > 0
          ) {
            if (
              this.detail.expectation &&
              this.detail.expectation.personality.length ==
                this.personalityList.length - 1
            ) {
              for (var c in this.personalityList) {
                if (this.personalityList[c].name == "Select All") {
                  this.personalityList[c].name = "Deselect All";
                }
              }
            }
          }

          if (!this.detail.brotherSisterObj) {
            this.detail.brotherSisterObj = {};
          }
          if (this.detail.expectation == null) {
            this.detail.expectation = {
              marital_status: [],
            };
          }
          const toAdd = Math.min(
            this.image_limit - this.detail.user_images.length,
            2
          );

          for (let i = 0; i < toAdd; i++) {
            this.detail.user_images.push({ image_id: i });
          }
          if (
            this.detail.family_details &&
            this.detail.family_details.familty_phone_numbers.length < 3
          ) {
            var count =
              Number(3) -
              Number(this.detail.family_details.familty_phone_numbers.length);
            for (var g = 1; g <= count; g++) {
              this.detail.family_details.familty_phone_numbers.push({
                type: "",
                phone: "",
                custom_type_name: "",
                is_whatsapp: "N",
                is_phone: "N",
              });
            }
          }

          //set dob

          this.$refs.dobDatePicker.setDateValueData(res.dob);
          this.getStatusList("CHARAN", this.detail.nakshatra_id);
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res);
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    updateWhatsappFlag(data) {
      if (data.is_whatsapp == "N") {
        return (data.is_whatsapp = "Y");
      } else {
        return (data.is_whatsapp = "N");
      }
    },
    updateCallFlag(data) {
      if (data.is_phone == "N") {
        return (data.is_phone = "Y");
      } else {
        return (data.is_phone = "N");
      }
    },

    getStatusList(type, nakshatra_id) {
      var obj = {};
      obj.type = type;
      if (nakshatra_id) {
        obj.nakshatra_id = nakshatra_id;
      }
      this.$api
        .getAPI({
          _action: "/master-data/list",
          _body: obj,
        })
        .then((res) => {
          if (type == "MARITAL_STATUS") {
            this.marriedStatusList = [...this.marriedStatusList, ...res.list];
          }
          if (type == "DEVAK") {
            this.devakList = [...this.devakList, ...res.list];
          }
          if (type == "MARITAL_STATUS") {
            this.marriedStatusListNew = [
              ...this.marriedStatusListNew,
              ...res.list,
            ];
          }
          if (type == "BODY_STRUCTURE") {
            this.bodyStructureList = [...this.bodyStructureList, ...res.list];
          }
          if (type == "BODY_STRUCTURE") {
            this.bodyStructureListNew = [
              ...this.bodyStructureListNew,
              ...res.list,
            ];
          }
          if (type == "SKIN_TONE") {
            this.skintoneList = res.list;
          }
          if (type == "DIET") {
            this.dietList = [...this.dietList, ...res.list];
          }
          if (type == "DIET") {
            this.dietListNew = [...this.dietListNew, ...res.list];
          }
          if (type == "EDUCATION_GROUP") {
            this.educationGroupList = [...this.educationGroupList, ...res.list];
          }
          if (type == "EDUCATION_GROUP") {
            this.educationGroupListNew = [
              ...this.educationGroupListNew,
              ...res.list,
            ];
          }
          if (type == "PERSONALITY") {
            this.personalityList = [...this.personalityList, ...res.list];
          }
          if (type == "PERSONALITY") {
            this.personalityListNew = [...this.personalityListNew, ...res.list];
          }
          if (type == "OCCUPATION_TYPE") {
            this.occupationTypeList = [...this.occupationTypeList, ...res.list];
          }
          if (type == "RELATION") {
            this.relationList = [...this.relationList, ...res.list];
          }
          if (type == "OCCUPATION_TYPE") {
            this.occupationTypeListNew = [
              ...this.occupationTypeListNew,
              ...res.list,
            ];
          }
          if (type == "RAAS") {
            this.rashiList = res.list;
          }
          if (type == "NAKSHTRA") {
            this.nakshtraList = res.list;
          }
          if (type == "CHARAN") {
            this.charanList = res.list;
          }
          if (type == "NADI") {
            this.nadiList = res.list;
          }
          if (type == "GAN") {
            this.ganList = res.list;
          }
          if (type == "RELATION") {
            this.relationListNew = [...this.relationListNew, ...res.list];
          }
          if (type == "ECO_STATUS") {
            this.echoStatusList = [...this.echoStatusList, ...res.list];
          }
          if (type == "ECO_STATUS") {
            this.echoStatusListNew = [...this.echoStatusListNew, ...res.list];
          }
          if (type == "MOVE_TO_ABROAD") {
            this.moveToAbroadList = [...this.moveToAbroadList, ...res.list];
          }
          if (type == "MOVE_TO_ABROAD") {
            this.moveToAbroadListNew = [
              ...this.moveToAbroadListNew,
              ...res.list,
            ];
          }
        })
        .catch(() => {});
    },
    getMembershipPlanList() {
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.membershipPlanList = res.list;
        })
        .catch(() => {});
    },

    getTalukaList() {
      this.$api
        .getAPI({
          _action: "/taluka/list",
        })
        .then((res) => {
          this.nativeTalukaList = res;
        })
        .catch(() => {});
    },
    getWorkLocationList() {
      this.$api
        .getAPI({
          _action: "/work-location/list",
        })
        .then((res) => {
          this.worklocationList = res;
        })
        .catch(() => {});
    },
    getDistrictList() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.districtList = res;
        })
        .catch(() => {});
    },
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
        })
        .catch(() => {});
    },
    getStateList() {
      this.$api
        .getAPI({
          _action: "/state/list",
        })
        .then((res) => {
          this.stateList = res;
          this.$refs.errorComponent.updateFormLoader(false);
        })
        .catch(() => {});
    },
    moveToMarried() {
      var obj = {};
      obj.uuid = this.uuid;
      this.$api
        .postAPI({
          _action: "/move-to-married",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$router.push("/married-list/HIDE");
        })
        .catch(() => {});
    },
    moveToMemberList() {
      var obj = {};
      obj.uuid = this.uuid;
      this.$api
        .postAPI({
          _action: "/move-to-member",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$router.push("/married-list/HIDE");
        })
        .catch(() => {});
    },
    save() {
      if (this.detail.birth_time) {
        this.detail.birth_time = moment(this.detail.birth_time).format(
          "HH:mm:ss"
        );
      }
      if (this.uuid) {
        this.detail.uuid = this.uuid;
        this.$api
          .putAPI({
            _action: "/update/user",
            _body: this.detail,
            _buttonId: "save-button111",
          })
          .then((res) => {
            for (var j in this.detail.user_images) {
              var obsStep = "productImagePicker_" + j;
              this.uploadUserImage(
                res.uuid,
                this.$refs[obsStep][0].file,
                this.detail.user_images[j].uuid
              );
            }
            this.$router.push("/member-list");
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/add/user",
            _body: this.detail,
            _buttonId: "save-button111",
          })
          .then((res) => {
            for (var j in this.detail.user_images) {
              var obsStep = "productImagePicker_" + j;
              this.uploadUserImage(
                res.uuid,
                this.$refs[obsStep][0].file,
                this.detail.user_images[j].uuid
              );
            }
            this.$router.push("/member-list");
          })
          .catch(() => {});
      }
    },
    uploadUserImage(uuid, imageFile, image_id) {
      if (imageFile) {
        this.$api
          .uploadImageAPI({
            _action: "/add/photo",
            _key: "image",
            _file: imageFile,
            _body: {
              uuid: uuid,
              image_id: image_id ? image_id : "",
            },
          })
          .then(() => {});
      } else {
        this.$router.push("/member-list");
      }
    },
    showIdProofPopup() {
      // this.$refs.IdForm.resetForm();
      if (this.uuid) {
        this.getDoumentDetail();
      }
      this.$refs.textModal.increaseModelWidth();
      this.$refs.textModal.showModal();
    },
    saveIdProof() {
      if (
        !this.$refs.documentFrontImage.file &&
        !this.documentDetail.front_image
      ) {
        this.$notify({
          type: "error",
          text: "Please upload front image.",
        });
        return;
      }
      if (
        !this.$refs.documentBackImage.file &&
        !this.documentDetail.back_image
      ) {
        this.$notify({
          type: "error",
          text: "Please upload back image.",
        });
        return;
      }
      if (this.uuid) {
        this.documentDetail.user_id = this.uuid;
      }
      if (this.detail.document_id) {
        this.documentDetail.uuid = this.detail.document_id;
      }
      this.$api
        .postAPI({
          _action: "/add/document",
          _body: this.documentDetail,
          _buttonId: "save-document",
        })
        .then((res) => {
          this.detail.document_id = res.uuid;
          if (this.$refs.documentFrontImage.file) {
            this.uploadImage(
              res.uuid,
              "FRONT",
              this.$refs.documentFrontImage.file
            );
          } else if (this.$refs.documentBackImage.file) {
            this.uploadImage(
              res.uuid,
              "BACK",
              this.$refs.documentBackImage.file
            );
          } else {
            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
            this.$refs.textModal.closeModal();
          }
        })
        .catch(() => {});
    },
    uploadImage(uuid, image_type, file, type) {
      this.$api
        .uploadImageAPI({
          _action: "/add/document/photo",
          _key: "image",
          _file: file,
          _body: {
            uuid: uuid,
            image_type: image_type,
          },
        })
        .then(() => {
          if (this.$refs.documentBackImage.file && !type) {
            this.uploadImage(
              uuid,
              "BACK",
              this.$refs.documentBackImage.file,
              true
            );
          } else {
            this.getDoumentDetail();
            this.$refs.textModal.closeModal();
            this.$notify({
              type: "success",
              text: "Document uploaded successfully.",
            });
          }
        });
    },
    showBrotherSisterPopup() {
      this.detail.uuid = "";
      this.brotherSisterObj = {};
      this.brotherSisterObj.indx = null;
      this.$refs.BrotherSisterForm.resetForm();
      this.$refs.BrotherSisterModal.showModal();
    },

    onChange(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png" &&
        files[0].type.toLowerCase() != "image/svg+xml"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const sizeInKB = files.size / 1024; // Convert to KB
      if (sizeInKB > 400) {
        alert("Photo size should not exceed 400 KB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.detail.images.push({
        image: files[0],
        image_type: "FRONT",
      });
      document.getElementById("preview").src = tmppath;
    },
    selectedFile(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png" &&
        files[0].type.toLowerCase() != "image/svg+xml"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.back_image = files[0];
      this.detail.images.push({
        image: files[0],
        image_type: "BACK",
      });
      document.getElementById("back_image").src = tmppath;
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css">
/* .sidebar-wrapper {
  width: 0;
} */
.form-style .form-check-input {
  display: none;
}
.form-style label {
  font-size: 14px;
  margin-bottom: 3px;
  line-height: 16px;
}
.form-style .form-control {
  font-size: 14px;
  height: 30px;
  padding: 3px 6px;
}
.form-style .table tr td {
  padding: 3px 5px;
  font-size: 14px;
  line-height: 19px;
}
.form-style .table tr th {
  padding: 5px 5px;
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
}
</style>
<style scoped>
.multiselect {
  /* background: white !important; */
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #d35bc1 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}

.photo-slider .carousel-item img {
  height: 350px;
}
.photo-slider .carousel-indicators {
  position: initial;
  margin-bottom: 0;
  overflow-x: hidden;
  width: 482px;
  margin: 0 auto;
  justify-content: start;
}
.photo-slider .carousel-indicators li {
  background-color: #bd1c9c;
  text-indent: 0;
  border: 1px solid #c6c6c6;
  width: auto !important;
  height: auto;
  cursor: pointer;
}
.photo-slider .carousel-indicators li.active {
  border-color: #bd1c9c;
  box-shadow: 1px 1px 6px #4242427a;
}
.photo-slider .carousel-indicators .slider-thumb-img {
  width: 55px;
  height: 70px;
  object-fit: cover;
}
.carousel-indicators li:before,
.carousel-indicators li:after {
  content: unset;
}
.photo-slider .carousel-inner {
  padding-bottom: 15px;
}
.photo-slider .crop-thumbnail {
  position: absolute;
  top: 0;
  z-index: 999999;
  margin: 0 5px;
  background: #ffffffbf;
  padding: 3px 4px;
  line-height: 16px;
}
.photo-slider .horizon-prev {
  position: absolute;
  bottom: 32px;
}
.photo-slider .horizon-next {
  position: absolute;
  bottom: 32px;
  right: 0;
}

label {
  font-size: 13px;
}

.mb-2,
.my-2 {
  margin-bottom: 0.1rem !important;
}
</style>
